import { render, staticRenderFns } from "./Scales.vue?vue&type=template&id=f1991cec&scoped=true"
import script from "./Scales.vue?vue&type=script&lang=js"
export * from "./Scales.vue?vue&type=script&lang=js"
import style0 from "./Scales.vue?vue&type=style&index=0&id=f1991cec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1991cec",
  null
  
)

export default component.exports